import { fragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { Station } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';

export function isExternalExportEnabledV1(station: Station) {
  return get(station, 'featuresConfig.export.enabled', false);
}

export function useIsExternalExportEnabled(
  station: Station,
  { checkOnlyV2 = false }: { checkOnlyV2?: boolean } = {},
) {
  const query = useQuery({
    queryKey: ['isExternalExportEnabled', station.id],
    queryFn: async () => {
      if (isExternalExportEnabledV1(station) && !checkOnlyV2) {
        return true;
      }

      const result = await fragmentsDeliveryAPIStationConfigClientGetConfig(station.id);

      return !!result.enabled;
    },
  });

  return query.data;
}
